<template>
    <!-- 单选题 -->
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <div class="content">
                <!-- 地图模式 -->
                <div v-if="dataList.pattern == '1'" class="map-box">
                    <svg-icon name="location" class="svg-icon"></svg-icon>
                    获取地理位置
                </div>
                <!-- 输入框模式 -->
                <div v-else class="input-box">请输入地点、街道等位置信息</div>
            </div>
            <!-- 底部操作栏 -->
            <div class="footer-operation" v-if="footerShow">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                ></action-bar>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-location">
// js
import { ref, watch, provide } from "vue";

// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
// 复制题目，删除题目, 数据改变, 单题预览;
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]);
const titileInput = ref(null);

watch(
    () => props.dataList,
    (curr, old) => {
        emits("change", curr);
    },
    { deep: true }
);

provide("data", props.dataList);
defineExpose({ titileInput });
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;

.input-box {
    width: 496px;
    height: 30px;
    line-height: 30px;
    padding-left: 13px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(229, 232, 238, 1);
    font-size: 14px;
    color: rgba(183, 186, 191, 1);
}
.map-box {
    width: 369px;
    height: 37px;
    line-height: 37px;
    border-radius: 4px;
    background: rgba(127, 148, 242, 0.1);
    border: 1px solid rgba(127, 148, 242, 1);
    font-size: 14px;
    font-weight: 400;
    color: rgba(34, 64, 195, 1);
    text-align: center;
    .svg-icon {
        width: 13px;
        height: 15px;
        margin-right: 8px;
    }
}
</style>
